module.exports = __webpack_public_path__ + "static/media/map-marker.70c2bf5d.svg";